/**
 * Container for the Home component
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { AppMetaData } from '../../api/types'
import { Language } from '../../settings/types'
import { CodeStatus } from '../../lockapp/types'
import * as apiActions from '../../api/actions'
import { getConfiguration } from '../../configuration'
import { CouponCode } from '../../lockapp/types'
import { RedeemCode, Manifest } from 'mytours-read-api-typescript'

export interface Props {
	appMetaData: AppMetaData
	selectedLanguage?: Language
	lockApp?: CodeStatus
	appManifest?: Manifest
}

export interface Actions {
	validateCode: (couponCode: CouponCode, linkedId: number) => void
}

const mapStateToProps = (state: RootStoreState): Props => {
	const appMetaData: AppMetaData | undefined = state.settings.appMetaData

	// throwing error for now
	if (appMetaData === undefined) {
		throw Error('Must have meta data to load HomeStack')
	}

	return {
		appMetaData,
		selectedLanguage: state.settings.selectedLanguage,
		lockApp: state.lockapp.app,
		appManifest: state.settings.appManifest,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	validateCode: (couponCode: CouponCode, linkedId: number) => {
		const platform = getConfiguration().getPlatform()
		const deviceUUID = getConfiguration().getDeviceUUID()

		dispatch(
			apiActions.validateCode.started({
				linkedId,
				linkedType: RedeemCode.LinkedTypeEnum.Project,
				devicePlatform: platform,
				deviceUdid: deviceUUID,
				couponCode: couponCode.code,
				expireAt: couponCode.expireAt,
			}),
		)
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
